<div class='result'>
    <div [class]='"icon " + icon'></div>
    <a class='title focusable' clickOnReturn [attr.aria-label]='name + " - מיקוד המפה לשם"'
        (focus)='state.focusResults()' (blur)='state.blurResults()' (activated)='select()'
    ><span [innerHTML]='display'></span></a>
</div>
